import React from 'react';

import {ReactComponent as Facebook} from '../../assets/img/SVG/facebook-original.svg'
import {ReactComponent as Instagram} from '../../assets/img/SVG/instagram-original.svg';
import {ReactComponent as Twitter} from '../../assets/img/SVG/twitter-original.svg';

const Social = (props) => {
    const classes = ["social", props.className]
    return (
        <div className= {classes.join(" ")}>
            <a className = "social__link" href = "https://www.facebook.com/okiki.olufemi" target = "_blank" rel = "noopener noreferrer"><Facebook className = "social__link__svg" data-aos = "fade-left" /></a>
            <a className = "social__link" href = "https://www.instagram.com/_kikks7" target = "_blank" rel = "noopener noreferrer"><Instagram className = "social__link__svg" data-aos = "fade-left" data-aos-delay = "200" /></a>
            <a className = "social__link" href = "https://twitter.com/kikks07" target = "_blank" rel = "noopener noreferrer"><Twitter className = "social__link__svg" data-aos = "fade-left" data-aos-delay = "400" /></a>
        </div>
    );
};

export default Social;